export const SUREST_FILTER_API_URL = '/standard-search/topfilter';
export const SUREST_TIME_PERIOD_API_URL = '/date-filter-source/Surest';
export const SUREST_RELATIVE_GRAPH_API_URL = '/surest/relative-graph';
export const SUREST_RELATIVE_COST_DRIVERS = '/surest/relative-cost-drivers';
export const SUREST_RELATIVE_DISTRIBUTION = '/surest/relative-distribution';
export const SUREST_RELATIVE_COMMON_SERVICES = '/surest/relative-common-services';
